import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import RadioGroupSet from '@shared/components/inputs/Radio/RadioGroupSet';
import TextFieldLabel from '@shared/components/inputs/TextFieldLabel/TextFieldLabel';
import type { BillDeliverySectionProps } from '@components/Checkout/steps/CustomerInfoStep/CustomerInfoStep.types';

const BILL_DELIVERY_OPTIONS = [
  { value: 'email', label: 'Email (Paperless E-bill)' },
  { value: 'postal', label: 'Postal (Paper Bill Delivered by Mail to the Billing Address)' },
];

export const BillDeliverySection = ({ formik }: BillDeliverySectionProps) => {
  const { values, handleChange } = formik;

  return (
    <>
      <Typography variant="heading.subsection" sx={{ lineHeight: '150%' }}>
        Bill Delivery
      </Typography>
      <Stack gap="9px">
        <TextFieldLabel label="How Would You Like to Receive Your Monthly Invoice?" />
        <RadioGroupSet
          name="billDelivery"
          value={values.billDelivery}
          onChange={handleChange}
          options={BILL_DELIVERY_OPTIONS}
        />
      </Stack>
    </>
  );
};
